import React, { lazy, useCallback, useRef, useState } from "react";

const ActionButtons = lazy(() => import("./ActionButtons"));

const CustomRow = (props) => {
  const { e, actions, actionButtonType, core, appId, dataLoaderComponent, isFetchingRef, currentRow, parentRef } = props;
  const [actionButtonsData, setActionButtonsData] = useState({
    enabled: false,
    style: {
      top: 0,
      right: 0,
    },
  });
  const isDefaultPresent = actions?.some(action => action.defaultAction)
  const actionButtonsRef = useRef();

  const calculatePosition = useCallback((element) => {
    if (!element) return { top: 0, right: 16 };

    try {
      const rect = element.getBoundingClientRect();
      const gridContainer = parentRef?.current;
      const gridRect = gridContainer?.getBoundingClientRect();

      if (!gridRect) return { top: rect.top + rect.height / 2 - 20, right: 16 };

      return {
        top: rect.top + rect.height / 2 - 20,
        right: window.innerWidth - gridRect.right + 16,
      };
    } catch (error) {
      return { top: 0, right: 16 };
    }
  }, []);

  const showActionButtons = () => {
    const { dataItem, trProps } = e;
    if (!actionButtonType && actions?.length > 0 && appId) {
      const position = calculatePosition(trProps.ref.current);
      setActionButtonsData({
        enabled: true,
        style: position,
      });
    }
  };

  const hideActionButtons = (e) => {
    if (actionButtonsRef.current && actionButtonsRef?.current?.contains?.(e.relatedTarget)) {
      return;
    }
    setActionButtonsData({
      enabled: false,
      data: {},
    });
  };

  return (
    <>
      <tr
        {...e.trProps}
        data-row-id={e.dataItem.uuid || e.dataItem.file_uuid || e.dataItem.id}
        onMouseLeave={hideActionButtons}
        onMouseEnter={showActionButtons}
        style={actionButtonsData?.enabled && isDefaultPresent ? { cursor: "pointer", color: "#0000EE" } : {}}
      >
        {actionButtonsData.enabled && (
          <ActionButtons
            showActionButtons={actionButtonsData.enabled}
            position={actionButtonsData.style}
            actions={actions}
            actionButtonType={actionButtonType}
            core={core}
            appId={appId}
            dataItem={e.dataItem}
            rowId={e.dataItem.uuid || e.dataItem.file_uuid || e.dataItem.id}
            dataLoaderComponent={dataLoaderComponent}
            isFetchingRef={isFetchingRef}
            currentRow={currentRow}
          />
        )}
        {e.children}
      </tr>
    </>
  );
};

export default CustomRow;
